import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import AddPasskeyModal from './AddPasskeyModal';
/**
 * Surfaces the post-login passkey suggestion as a focused modal rather than
 * an inline alert. Clicking "Set up" hands off to {@link AddPasskeyModal} so
 * the registration ceremony runs from a fresh user gesture (Safari refuses
 * passkey prompts that land more than one frame after a click).
 *
 * The modal is dismissable: closing via the X, the Not now button, or the
 * backdrop all route through the same dismissal callback so the 30-day
 * cool-down cannot be sidestepped.
 */
export default class SuggestPasskeyModal extends Modal {
  constructor() {
    super(...arguments);
    // True when the user explicitly handed off to AddPasskeyModal via Set up.
    // Without this we cannot tell apart "user accepted" from "user closed",
    // and the dismissal cool-down would fire on every accept.
    _defineProperty(this, "accepted", false);
  }
  className() {
    return 'SuggestPasskeyModal Modal--small';
  }
  title() {
    return app.translator.trans('datlechin-passkey.forum.suggest.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form Form--centered"
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('datlechin-passkey.forum.suggest.body')), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      onclick: this.setUp.bind(this)
    }, app.translator.trans('datlechin-passkey.forum.suggest.set_up'))), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--text Button--link",
      onclick: () => this.hide()
    }, app.translator.trans('datlechin-passkey.forum.suggest.not_now')))));
  }
  onbeforeremove(vnode) {
    if (!this.accepted) {
      var _this$attrs$onDismiss, _this$attrs;
      (_this$attrs$onDismiss = (_this$attrs = this.attrs).onDismiss) == null || _this$attrs$onDismiss.call(_this$attrs);
    }
    return super.onbeforeremove(vnode);
  }
  setUp() {
    this.accepted = true;
    // app.modal.show replaces the current modal stack; calling hide() first
    // races with that replacement and leaves the new modal in a half-open
    // state where its loading flag never resets after a successful submit.
    app.modal.show(AddPasskeyModal);
  }
}
flarum.reg.add('datlechin-passkey', 'forum/components/SuggestPasskeyModal', SuggestPasskeyModal);